import { InputGroup, FormControl } from "react-bootstrap";
import { useLabels } from "../Label";

const GlobalFilter = ({ filter, setFilter }) => {
    const fLabel = useLabels()
    const placeholder = fLabel({ data: 'LabelSearch' });
    return (
        <InputGroup size="sm" className="mb-3 mt-3 float-end w-25">
            <FormControl
                aria-label={fLabel({ data: "HeaderSmall" })}
                aria-describedby="inputGroup-sizing-sm"
                value={filter || ""}
                onChange={(e) => setFilter(e.target.value)}
                placeholder={placeholder}
            />
        </InputGroup>
    );
};

export default GlobalFilter;
